module.exports = __webpack_public_path__ + "assets/img/logo-mini.46d08dce.png";